import React from "react";
import { useChatbot } from "./chatBotContext";
import SearchAgentSuiteComponent from './agentChat';

export default function SearchAgentSuite() {
  const { isVisible } = useChatbot();

  if (!isVisible) return null;
  return <SearchAgentSuiteComponent />;
}